import {
    getLocalParticipant,
    hiddenParticipantJoined,
    hiddenParticipantLeft,
    participantJoined,
    participantLeft
} from '../participants';
import { toState } from '../redux';
import { safeDecodeURIComponent } from '../util';
import { getConferenceName as _getConferenceName, getConferenceNameForTitle as _getConferenceNameForTitle } from './functions';

export * from './functions';

export function getConferenceName(stateful: Function | Object): string {
    const state = toState(stateful);
    const { meeting } = state['features/base/conference'];
    if(meeting && meeting.name) { return meeting.name; }
    else { return _getConferenceName(stateful) }
}

export function getConferenceNameForTitle(stateful: Function | Object) {
    const state = toState(stateful);
    const { meeting } = state['features/base/conference'];
    if(meeting && meeting.name) { return meeting.name; }
    else { return _getConferenceNameForTitle(stateful) }
}